export default function Select(props) {
  return (
    <select
      {...props}
      className={
        "w-full rounded-2xl bg-white border border-gray-300 px-4 py-4 text-gray-900 " +
        "focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
      }
    />
  );
}
